import { Language, UserMenuItem } from '@tymes4-shared';
import { MenuItemView, UserSalesChannelView } from '../api';
import { UserSalesChannel, Language as SessionLanguage } from "@tymes4-shared";


export class MappingHelper {
    public static MapMenuItemViewToMenuItem(menuItemView: MenuItemView): UserMenuItem {
        const menuItem: UserMenuItem = {
            Icon: menuItemView.Icon,
            Name: menuItemView.Name,
            State: menuItemView.State,
            SubItems: menuItemView.SubItems?.map(s => this.MapMenuItemViewToMenuItem(s)) ?? [],
            ToolTip: menuItemView.ToolTip,
            Type: menuItemView.Type
        };
        return menuItem;
    }

    public static MapUserSalesChannelViewToUserSalesChannel(salesChannelView: UserSalesChannelView): UserSalesChannel {
        const salesChannel: UserSalesChannel = {
            HexColor: salesChannelView.HexColor,
            IsPrimary: salesChannelView.IsPrimary,
            Name: salesChannelView.Name,
            SalesChannelId: salesChannelView.SalesChannelId,
            SalesGroupId: salesChannelView.SalesGroupId,
            UserId: salesChannelView.UserId
        };
        return salesChannel;
    }
    public static MapAPILanguageToSessionLanguage(language : Language) : SessionLanguage {
        const lang : SessionLanguage = {
            Id: language.Id,
            Code: language.Code,
            Name: language.Name,
            Locale: language.Locale,
            IsDefault: language.IsDefault,
            CssClass: language.CssClass,
            Created:  new Date(language.Created),
            Deleted: new Date(language.Deleted),
            Modified: new Date(language.Modified),

            TimeZone: language.TimeZone,
            FormatDate: language.FormatDate,
            FormatDateTime: language.FormatDateTime,
            FormatTime: language.FormatTime
        };

        return lang;
    }
}

